import { useRef } from 'react'
import styled from 'styled-components'

import { FadeOverflow, hiddenScrollbarCss } from '@root/shared/ui-kit'
import { HorizontalList } from '@root/shared/ui-kit/horizontal-list'

import { SearchRecentPairItem } from './search-recent-pair-item'

import type { Pair, PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type SearchRecentProps = {
  pairs: Array<PairModel>
  onPairSelected?: (pair: Pair.PairMinimal) => void
} & ClassNameProps

export const SearchRecentList: React.FC<SearchRecentProps> = ({
  className,
  pairs,
  onPairSelected,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const recentPairs = pairs
  const withScrollbar = pairs.length > 9

  return (
    <HorizontalList
      transformScrollBehavior
      scrollRef={scrollRef}
      arrowsBackground="var(--background-1)"
    >
      <RecentPairs
        ref={scrollRef}
        className={className}
        mode={withScrollbar ? 'always' : 'edge'}
        variant="horizontal"
      >
        {recentPairs.map((pair) => (
          <Item key={pair.address} pair={pair} onClick={onPairSelected} />
        ))}
      </RecentPairs>
    </HorizontalList>
  )
}

const RecentPairs = styled(FadeOverflow)`
  display: grid;
  grid-auto-flow: column;
  padding-inline: 2px;

  overflow-x: auto;
  align-content: start;
  scrollbar-width: none;
  ${hiddenScrollbarCss}

  width: 100%;
  align-items: start;
  justify-content: start;
`

const Item = styled(SearchRecentPairItem)`
  padding: 0 6px;
`
